/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../../../modules/auth/core/Auth'



const Todo: React.FC = () => {
  const { currentUser } = useAuth()

  useEffect(() => {
    // no-op for now, kept if future side-effects are needed
  }, [])

  return (
    <div className='card shadow mb-5 mb-xl-10 bgi-no-repeat'
      style={{
        backgroundPosition: 'top right',
        backgroundSize: '100% auto',
        backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
        paddingRight: '0px'
      }}
    >

      <div className='card-body pt-9 pb-0'>
        <div className='flex-grow-1'>
          <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center mb-2'>
                <a className='text-black text-hover-primary fs-2 fw-bolder me-1' style={{ textTransform: 'capitalize' }}>
                  Todo
                </a>
              </div>
            </div>
          </div>
          <div className='d-flex flex-wrap flex-stack'>
            <div className='d-flex flex-column flex-grow-1 pe-8'>
              <div className='d-flex flex-wrap'>
                    {/* Conditional todo items */}
                    {currentUser?.IsDefaultPasswordNotify && (
                      <div className='mb-3 p-3 rounded bg-danger bg-opacity-10 border border-danger'>
                        <div className='d-flex align-items-center'>
                          <div className='me-3'>
                            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-2x svg-icon-danger' />
                          </div>
                          <div>
                            <div className='fs-6 fw-semibold text-danger'>Change the default password for security reasons</div>
                            <div className='fs-7 text-muted'>Your account is still using the default password. Update it now to keep your account secure.</div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!currentUser?.PhoneNumber && (
                      <div className='mb-3 p-3 rounded bg-warning bg-opacity-10 border border-warning'>
                        <div className='d-flex align-items-center'>
                          <div className='me-3'>
                            <KTSVG path='/media/icons/duotune/communication/com006.svg' className='svg-icon-2x svg-icon-warning' />
                          </div>
                          <div>
                            <div className='fs-6 fw-semibold text-dark'>Update your phone number to access policy details in WhatsApp</div>
                            
                          </div>
                        </div>
                      </div>
                    )}

                    {/* When there are no todos */}
                    {!currentUser?.IsDefaultPasswordNotify && currentUser?.PhoneNumber && (
                      <div className='mb-3'>
                        <div className='alert alert-success mb-0'>
                          Hey, all things up to date
                        </div>
                      </div>
                    )}

              </div>
            </div>
          </div>

          
        </div>

        
      </div>
    </div>
  )


}

export { Todo }
